"use client";

import React from "react";
import { Button } from "../button.js";
import { ExternalLink } from "lucide-react";

interface CrmLinkButtonProps {
  description?: string;
  authToken?: string;
}

export function CrmLinkButton({ description, authToken }: CrmLinkButtonProps) {
  // Function to extract item_ID and board_ID from the description
  const extractCRMDetails = (desc: string) => {
    const match = desc.match(
      /Link to Client in CRM: https:\/\/schooleymitchellwesttn\.monday\.com\/boards\/(\w+?)\/pulses\/(\w+)/
    );
    if (match) {
      const [_, boardId, itemId] = match;
      
return { boardId, itemId };
    }
    
return null;
  };

  const crmDetails = extractCRMDetails(description || '');

  if (!crmDetails) {
    return null;
  }

  return (
    <div className="space-y-2">
      <Button
        variant="outline"
        size="sm"
        onClick={() => {
          const url = `/crm/meeting/?itemId=${crmDetails.itemId}&boardId=${crmDetails.boardId}`;
          window.open(url, '_blank');
        }}
        className="flex items-center space-x-2"
      >
        <ExternalLink className="h-4 w-4" />
        <span>View Client Details</span>
      </Button>
      
      {/* TODO: Add LogMondayMeeting component when available */}
      {/* <LogMondayMeeting
        isMobile={false}
        generalSales={true}
        boardId={crmDetails.boardId}
        itemID={crmDetails.itemId}
        customerName={crmDetails.itemId}
        authToken={authToken}
        openDefault={false}
        noReminder={true}
      /> */}
    </div>
  );
}
